// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"or_a bhr_qt bhr_a bhr_w","FaqAskQuestion__outdated":"or_b bhr_vr bhr_xg"};